// extracted by mini-css-extract-plugin
module.exports = {"form-box":"form-box_form-box__lTeod"};